import React from 'react';

import "../index.css"

import { round } from '../utils';
import { DECIMAL_LIMIT } from '../constants';


const DispatchNoteItems = (props) => {
    const { buyerReqItem, buyerReqWiseDispatchNoteItems, buyerPOItem, buyerPOItemWiseDispatchNoteItems, groupBuyerInvoiceItemsBy } = props

    const handleDeleteClick = (selectedBuyerReqItemId) => {
        let relatedBuyerReqWiseDispatchNoteItems = buyerReqWiseDispatchNoteItems.filter(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId !== selectedBuyerReqItemId)
        let relatedBuyerReqItems = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === selectedBuyerReqItemId)

        relatedBuyerReqItems.replacedBuyerReqItems.map(eachReplacedBuyerReqItem => {
            let relatedBuyerReqDispatchNoteItem = relatedBuyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachReplacedBuyerReqItem.buyerReqItemId)
            if(relatedBuyerReqDispatchNoteItem){
                relatedBuyerReqDispatchNoteItem.qty += round(eachReplacedBuyerReqItem.qty, DECIMAL_LIMIT)
                relatedBuyerReqDispatchNoteItem.totalAmount = round(relatedBuyerReqDispatchNoteItem.qty * eachReplacedBuyerReqItem.unitPrice,DECIMAL_LIMIT)
                //relatedBuyerReqDispatchNoteItem.totalQty += parseInt(eachReplacedBuyerReqItem.qty)
            }
            else{
                relatedBuyerReqWiseDispatchNoteItems.push(eachReplacedBuyerReqItem)
            }
        })

        props.setBuyerReqWiseDispatchNoteItems([...relatedBuyerReqWiseDispatchNoteItems])
    }

    let productName = ""
    let productSpecification = ""

    if(buyerReqItem){
        productName = buyerReqItem?.companyProdName ? buyerReqItem?.companyProdName : buyerReqItem?.productName
        productSpecification = buyerReqItem?.companyProdSpec ? buyerReqItem?.companyProdSpec : buyerReqItem?.productSpecification
    } else if(buyerPOItem){
        productName = buyerPOItem?.companyProdName ? buyerPOItem?.companyProdName : buyerPOItem?.productName
        productSpecification = buyerPOItem?.companyProdSpec ? buyerPOItem?.companyProdSpec : buyerPOItem?.productSpecification
    }
    
    return (
        <>
            {
                groupBuyerInvoiceItemsBy === "buyerPOItemId" ? 
                <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                    <td className="custom-td">{buyerPOItem?.materialId}</td>
                    <td className="custom-td">{productName} | {productSpecification}</td>
                    <td className="custom-td">{buyerPOItem?.UOM}</td>
                    <td className="custom-td">{buyerPOItem.unitPrice}</td>
                    <td className="custom-td">{buyerPOItem.qty}</td>
                    {/*<td className="custom-td">{buyerReqItem.unitPrice * buyerReqItem.qty}</td>*/}
                    <td className="custom-td">{buyerPOItem.totalAmount}</td>
                    <td className="custom-td">
                        {/*
                            buyerReqItem?.replacedBuyerReqItems && buyerReqItem?.replacedBuyerReqItems?.length > 0 ? 
                            <i className="pi pi-trash" style={{ fontSize: '0.8rem', cursor: "pointer" }} onClick={() => handleDeleteClickBuyerPOItemLevel(buyerPOItem.buyerPOItemId)} disabled={buyerPOItem.replacedBuyerReqItems}></i> : "" 
                        */}
                    </td>
                </tr>
                :
                <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                    <td className="custom-td">{buyerReqItem?.materialId}</td>
                    <td className="custom-td">{productName} | {productSpecification}</td>
                    <td className="custom-td">{buyerReqItem?.UOM}</td>
                    <td className="custom-td">{buyerReqItem.unitPrice}</td>
                    <td className="custom-td">{buyerReqItem.qty}</td>
                    {/*<td className="custom-td">{buyerReqItem.unitPrice * buyerReqItem.qty}</td>*/}
                    <td className="custom-td">{buyerReqItem.totalAmount}</td>
                    <td className="custom-td">
                        {
                            buyerReqItem?.replacedBuyerReqItems && buyerReqItem?.replacedBuyerReqItems?.length > 0 ? 
                            <i className="pi pi-trash" style={{ fontSize: '0.8rem', cursor: "pointer" }} onClick={() => handleDeleteClick(buyerReqItem.buyerReqItemId)} disabled={buyerReqItem.replacedBuyerReqItems}></i> : ""
                        }
                    </td>
                </tr>
            }
        </>
    )
}

export default DispatchNoteItems;